/**
 * 論理データモデル『帳票出力状況検索用情報』の型定義
 */
export interface IReportOutputStatusSearchInfo {
  blTenantId?: string | null;
  blUserId?: string | null;
  organizationCode?: string | null;
  employeeCode?: string | null;
  /** 画面ID */
  pageId?: string | null;
  pageIds?: Array<any> | null;
  /** 抽出日(開始) */
  searchDateStart?: string | null;
  /** 抽出日(終了) */
  searchDateEnd?: string | null;
  /** 出力状況区分 */
  outputStatusDiv?: string | null;
  /** 出力状況区分のEnum名称 */
  outputStatusDivEnumName?: string | null;
}

/**
 * 検索条件グループ区分
 */
export enum SearchConditionGroupDiv {
  /** グループ1 */
  G1,

  /** グループ2 */
  G2
}



// WEBPACK FOOTER //
// ./src/app/page/report-output-status-page/report-output-status-define.ts